<template>
  <!-- Gradient Bar with Labels -->
  <div class="gradient-bar-container">
    <div class="gradient-bar" :style="{ background: gradientBackground }"></div>
    <div class="legend-labels">
      <span v-for="(label, index) in labels" :key="index" class="legend-label">
        {{ label }}
      </span>
    </div>
    <div class="unit-label">{{ unit }}</div>
  </div>
</template>
  
  <script>
export default {
  props: {
    labels: Array,
    gradientColors: Array,
    unit: String,
  },
  computed: {
    gradientBackground() {
      return `linear-gradient(to right, ${this.gradientColors.join(", ")})`;
    },
  },
};
</script>
  
  <style scoped>
.gradient-bar-container {
  position: absolute;
  width: 100%;
  height: 25px;
}

.gradient-bar {
  height: 100%;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid #ccc;
  border-color: #002d4f;
}

.legend-labels {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  padding: 0 15px;
  pointer-events: none; /* Make sure the labels don't interfere with the gradient bar interaction */
}

.legend-label {
  color: white; /* Set text color to white */
  font-weight: bold;
  padding: 2px 4px;
  border-radius: 3px;
}

.unit-label {
  position: absolute;
  top: 0;
  left: 100%;
  background-color: #002d4f; /* Dark blue background */
  color: white; /* White text */
  font-weight: bold;
  padding: 0 6px;
  border-radius: 0px 5px 5px 0px; /* Rounded corners on the right side */
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  justify-content: center;
}
</style>
  

  